<template>
  <el-container class="app-container">
    <!-- 侧边栏 -->
    <el-aside :width="isCollapse ? '64px' : '220px'" class="app-aside">
      <div class="aside-header" @click="goHome">
        <span v-if="!isCollapse" class="header-title">联盟管理系统</span>
        <span v-else class="header-title-short">联盟</span>
      </div>

      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :collapse-transition="false"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        router
        class="app-menu"
      >
        <!-- 工作台 -->
        <el-menu-item index="/dashboard">
          <i class="el-icon-s-home"></i>
          <span slot="title">工作台</span>
        </el-menu-item>

        <!-- 创业扶持（代理端） -->
        <el-submenu index="entrepreneurship-sub" v-if="userRole !== 'customer' && !isAdmin">
          <template slot="title">
            <i class="el-icon-s-promotion"></i>
            <span>创业扶持</span>
          </template>
          <el-menu-item index="/entrepreneurship/apply">提交新申请</el-menu-item>
          <el-menu-item index="/entrepreneurship/my-applications">我的申请</el-menu-item>
        </el-submenu>

        <!-- 创业管理（管理员端） -->
        <el-submenu index="entrepreneurship-admin-sub" v-if="isAdmin">
          <template slot="title">
            <i class="el-icon-s-management"></i>
            <span>创业管理</span>
          </template>
          <el-menu-item index="/admin/entrepreneurship-list">申请列表</el-menu-item>
        </el-submenu>

        <!-- 官方联络 -->
        <el-menu-item index="/contact/index" v-if="userRole !== 'customer'">
          <i class="el-icon-phone-outline"></i>
          <span slot="title">官方联络</span>
        </el-menu-item>

        <!-- 消息中心 -->
        <el-menu-item index="/notify/index">
          <i class="el-icon-bell"></i>
          <span slot="title">消息中心</span>
          <el-badge v-if="notifyUnread > 0" :value="notifyUnread" class="menu-badge" />
        </el-menu-item>

        <!-- 公告 -->
        <el-submenu index="notice-sub">
          <template slot="title">
            <i class="el-icon-message-solid"></i>
            <span>公告信息</span>
            <el-badge v-if="unreadCount > 0" :value="unreadCount" class="menu-badge" />
          </template>
          <el-menu-item index="/notice/list">公告列表</el-menu-item>
          <el-menu-item index="/notice/create" v-if="userRole === 'admin'">发布公告</el-menu-item>
        </el-submenu>

        <!-- 留言板 -->
        <el-menu-item index="/messages">
          <i class="el-icon-s-comment"></i>
          <span slot="title">留言板</span>
        </el-menu-item>

        <!-- 聊天室 -->
        <el-menu-item index="/chat">
          <i class="el-icon-chat-dot-round"></i>
          <span slot="title">聊天室</span>
        </el-menu-item>

        <!-- 任务中心 -->
        <el-submenu index="task-sub" v-if="userRole !== 'customer'">
          <template slot="title">
            <i class="el-icon-medal"></i>
            <span>任务中心</span>
          </template>
          <el-menu-item index="/task/index">任务列表</el-menu-item>
          <el-menu-item index="/referral/index">推广链接</el-menu-item>
        </el-submenu>

        <!-- 团队管理 -->
        <el-submenu index="agent-sub" v-if="userRole !== 'customer' && userRole !== 'town'">
          <template slot="title">
            <i class="el-icon-s-cooperation"></i>
            <span>团队管理</span>
          </template>
          <el-menu-item index="/agent/team">我的团队</el-menu-item>
          <el-menu-item index="/agent/sales-report" v-if="['admin','province','city','county'].includes(userRole)">销售报表</el-menu-item>
          <el-menu-item index="/admin/sub-admins" v-if="isAdmin">下级管理员</el-menu-item>
        </el-submenu>

        <!-- 客户管理 -->
        <el-menu-item index="/agent/customers" v-if="userRole !== 'customer'">
          <i class="el-icon-user-solid"></i>
          <span slot="title">客户管理</span>
        </el-menu-item>

        <!-- 客户跟进 -->
        <el-menu-item index="/followup/index" v-if="userRole !== 'customer'">
          <i class="el-icon-phone-outline"></i>
          <span slot="title">客户跟进</span>
        </el-menu-item>

        <!-- 商品管理 -->
        <el-menu-item index="/product/list" v-if="userRole !== 'customer'">
          <i class="el-icon-s-goods"></i>
          <span slot="title">商品管理</span>
        </el-menu-item>

        <!-- 订单管理 -->
        <el-submenu index="order-sub">
          <template slot="title">
            <i class="el-icon-s-order"></i>
            <span>订单管理</span>
          </template>
          <el-menu-item index="/order/list">订单列表</el-menu-item>
          <el-menu-item index="/order/create">创建订单</el-menu-item>
        </el-submenu>

        <!-- 发货管理 -->
        <el-submenu index="shipping-sub" v-if="['admin','province','city','county','town'].includes(userRole)">
          <template slot="title">
            <i class="el-icon-truck"></i>
            <span>发货管理</span>
          </template>
          <el-menu-item index="/shipping/pending">待发货订单</el-menu-item>
          <el-menu-item index="/shipping/warehouse" v-if="userRole === 'admin'">仓库管理</el-menu-item>
        </el-submenu>

        <!-- 我的钱包 -->
        <el-menu-item index="/agent/wallet" v-if="userRole !== 'customer'">
          <i class="el-icon-money"></i>
          <span slot="title">我的钱包</span>
        </el-menu-item>

        <!-- 积分管理 -->
        <el-menu-item index="/points/index" v-if="userRole !== 'customer'">
          <i class="el-icon-price-tag"></i>
          <span slot="title">积分管理</span>
        </el-menu-item>

        <!-- 提成记录 -->
        <el-submenu index="commission-sub" v-if="userRole !== 'customer'">
          <template slot="title">
            <i class="el-icon-s-finance"></i>
            <span>提成记录</span>
          </template>
          <el-menu-item index="/agent/commission">提成记录</el-menu-item>
          <el-menu-item index="/admin/referral-points-rules" v-if="isAdmin">推广积分规则</el-menu-item>
        </el-submenu>

        <!-- 装机软件 -->
        <el-menu-item index="/tool/list" v-if="userRole !== 'customer'">
          <i class="el-icon-s-tools"></i>
          <span slot="title">装机软件</span>
        </el-menu-item>

        <!-- 装机知识 -->
        <el-submenu index="knowledge-sub" v-if="userRole !== 'customer'">
          <template slot="title">
            <i class="el-icon-notebook-2"></i>
            <span>装机知识</span>
          </template>
          <el-menu-item index="/knowledge/list">知识列表</el-menu-item>
          <el-menu-item index="/knowledge/create" v-if="isAdmin">发布知识</el-menu-item>
        </el-submenu>

        <!-- 商品素材 -->
        <el-submenu index="material-sub" v-if="userRole !== 'customer'">
          <template slot="title">
            <i class="el-icon-s-marketing"></i>
            <span>商品素材</span>
          </template>
          <el-menu-item index="/material/list">素材列表</el-menu-item>
          <el-menu-item index="/material/create" v-if="isAdmin">发布素材</el-menu-item>
        </el-submenu>

        <!-- 审计日志 -->
        <el-menu-item index="/audit/logs" v-if="isAdmin">
          <i class="el-icon-s-check"></i>
          <span slot="title">审计日志</span>
        </el-menu-item>

        <!-- 其它功能 -->
        <el-submenu index="other-sub">
          <template slot="title">
            <i class="el-icon-more"></i>
            <span>其它功能</span>
          </template>
          <el-menu-item index="/change-password">
            <i class="el-icon-lock"></i>
            <span slot="title">修改密码</span>
          </el-menu-item>
          <el-menu-item index="/account/list" v-if="userRole === 'admin'">
            <i class="el-icon-s-custom"></i>
            <span slot="title">账号管理</span>
          </el-menu-item>
          <el-menu-item index="/admin/agreement" v-if="isAdmin">
            <i class="el-icon-document"></i>
            <span slot="title">合作协议</span>
          </el-menu-item>
          <el-menu-item index="/admin/homepage-links" v-if="isAdmin">
            <i class="el-icon-link"></i>
            <span slot="title">首页链接</span>
          </el-menu-item>
          <el-menu-item index="/admin/recharge-content" v-if="isAdmin">
            <i class="el-icon-sell"></i>
            <span slot="title">充值内容</span>
          </el-menu-item>
          <el-menu-item index="/admin/ads" v-if="isAdmin">
            <i class="el-icon-s-flag"></i>
            <span slot="title">广告管理</span>
          </el-menu-item>
          <el-menu-item index="/admin/marquee-ads" v-if="isAdmin">
            <i class="el-icon-s-flag"></i>
            <span slot="title">滚动广告</span>
          </el-menu-item>
          <el-menu-item index="/admin/database-backup" v-if="isAdmin">
            <i class="el-icon-coin"></i>
            <span slot="title">数据库备份</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>

    <!-- 主内容区 -->
    <el-container>
      <!-- 顶部导航 -->
      <el-header class="app-header">
        <div class="header-left">
          <span class="collapse-btn" @click="toggleCollapse">
            <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
          </span>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentTitle">{{ currentTitle }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="user-info">
              <i class="el-icon-user-solid"></i>
              {{ userName }}
              <span class="role-tag">{{ roleName }}</span>
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">个人中心</el-dropdown-item>
              <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 页面内容 -->
      <el-main class="app-main">
        <router-view />
      </el-main>
    </el-container>

    <!-- 修改密码对话框 -->
    <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" width="450px"
      :close-on-click-modal="false" :show-close="!forceChangePwd">
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
        <el-form-item label="当前账号">
          <el-input :value="currentUserPhone" disabled></el-input>
        </el-form-item>
        <el-form-item label="原密码" v-if="!isFirstLogin">
          <el-input v-model="passwordForm.old_password" type="password" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input v-model="passwordForm.new_password" type="password" placeholder="8位以上，含数字+字母+符号"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirm_password">
          <el-input v-model="passwordForm.confirm_password" type="password" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <div style="padding-left:100px;color:#909399;font-size:12px;margin-top:-10px;" v-if="isFirstLogin">
        * 首次登录设置密码
      </div>
      <div style="padding-left:100px;color:#909399;font-size:12px;margin-top:-10px;" v-else>
        * 需验证原密码
      </div>
      <span slot="footer">
        <el-button @click="passwordDialogVisible = false" v-if="!forceChangePwd">取消</el-button>
        <el-button type="primary" @click="submitChangePassword" :loading="submittingPassword">确认修改</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { changePassword, getUnreadCount, getNotifyUnreadCount } from '@/api'
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',
  data() {
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.passwordForm.new_password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      isCollapse: false,
      unreadCount: 0,
      notifyUnread: 0,
      passwordDialogVisible: false,
      submittingPassword: false,
      passwordForm: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      passwordRules: {
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 8, message: '密码长度不能少于8位', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirm, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['userRole', 'userName', 'isAdmin']),
    currentUserPhone() {
      const user = JSON.parse(localStorage.getItem('user') || '{}')
      return user.phone || user.username || ''
    },
    activeMenu() {
      return this.$route.path
    },
    currentTitle() {
      return this.$route.meta ? this.$route.meta.title : ''
    },
    roleName() {
      const roleMap = {
        admin: '管理员',
        province: '省代理',
        city: '市代理',
        county: '县代理',
        town: '镇代理',
        customer: '会员'
      }
      return roleMap[this.userRole] || ''
    },
    forceChangePwd() {
      // 远程装机/上门装机（town角色）首次登录必须改密
      return this.userRole === 'town' && this.$store.state.user.is_first_login
    },
    isFirstLogin() {
      return this.$store.state.user && this.$store.state.user.is_first_login
    },
  },
  created() {
    this.fetchUnreadCount()
    this.fetchNotifyUnread()
    this.unreadTimer = setInterval(() => { this.fetchUnreadCount(); this.fetchNotifyUnread() }, 60000)
    // 远程装机/上门装机（town角色）首次登录需修改密码
    this.$nextTick(() => {
      if (this.userRole === 'town' && this.$store.state.user.is_first_login) {
        this.openPasswordDialog()
      }
    })
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(path) {
        if (path === '/change-password') {
          this.openPasswordDialog()
          this.$router.replace('/chat')
        }
      }
    }
  },
  beforeDestroy() {
    if (this.unreadTimer) clearInterval(this.unreadTimer)
  },
  methods: {
    goHome() {
      this.$router.push('/dashboard')
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    async fetchUnreadCount() {
      try {
        const res = await getUnreadCount()
        this.unreadCount = res.data.unread_count || 0
      } catch (e) {
        // ignore
      }
    },
    async fetchNotifyUnread() {
      try {
        const res = await getNotifyUnreadCount()
        this.notifyUnread = res.data.unread_count || 0
      } catch (e) {
        // ignore
      }
    },
    handleCommand(command) {
      if (command === 'profile') {
        this.$router.push('/profile')
      } else if (command === 'logout') {
        this.$store.dispatch('logout')
        this.$router.push('/login')
      }
    },
    openPasswordDialog() {
      if (this.passwordDialogVisible) return  // 防止重复打开重置表单
      this.passwordForm = { old_password: '', new_password: '', confirm_password: '' }
      this.$nextTick(() => {
        if (this.$refs.passwordForm) {
          this.$refs.passwordForm.clearValidate()
        }
      })
      this.passwordDialogVisible = true
    },
    async submitChangePassword() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (!valid) return
        this.submittingPassword = true
        try {
          await changePassword(this.passwordForm)
          // 更新本地用户状态：标记已修改密码
          const user = { ...this.$store.state.user, is_first_login: false }
          this.$store.dispatch('updateUser', user)
          this.$message.success('密码修改成功')
          this.passwordDialogVisible = false
          // 首次登录改完密码后跳到聊天室
          if (this.$route.path !== '/chat') {
            this.$router.push('/chat')
          }
        } catch (e) {
          // error handled by interceptor
        } finally {
          this.submittingPassword = false
        }
      })
    }
  }
}
</script>

<style scoped>
.app-container {
  height: 100vh;
}

.app-aside {
  background-color: #304156;
  overflow-x: hidden;
}

.aside-header {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #202d3c;
  cursor: pointer;
}

.header-title {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
}

.header-title-short {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}

.app-menu {
  border-right: none !important;
}

.app-menu:not(.el-menu--collapse) {
  width: 220px;
}

.menu-badge {
  margin-left: 8px;
}

.app-header {
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.collapse-btn {
  font-size: 20px;
  cursor: pointer;
  color: #666;
}

.collapse-btn:hover {
  color: #409EFF;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #333;
}

.role-tag {
  font-size: 12px;
  color: #909399;
  background: #f0f2f5;
  padding: 2px 8px;
  border-radius: 10px;
}

.app-main {
  background: #f0f2f5;
  min-height: calc(100vh - 60px);
  padding: 20px;
}
</style>
